export default {
  state: {
    adItem: {
      original: {
        ID: null
      },
      edited: {
        ID: null
      }
    }
  },
  mutations: {
    setOriginalAdItem (state, value) { state.adItem.original = value },
    setEditedAdItem (state, value) { state.adItem.edited = value },
    setEditedTooltipImage (state, value) { state.adItem.edited.tooltipImage = value },
    setEditedTooltipTitle (state, value) { state.adItem.edited.tooltipTitle = value },
    setEditedTooltipDescription (state, value) { state.adItem.edited.tooltipDescription = value },
    setEditedMainImage (state, value) { state.adItem.edited.mainImage = value },
    setEditedMainHeader (state, value) { state.adItem.edited.mainHeader = value },
    setEditedMainTitle (state, value) { state.adItem.edited.mainTitle = value },
    setEditedMainBody (state, value) { state.adItem.edited.mainBody = value },
    setEditedCtaText (state, value) { state.adItem.edited.ctaText = value },
    setEditedCtaLink (state, value) { state.adItem.edited.ctaLink = value },
    setEditedBrandId (state, value) { state.adItem.edited.brandId = value },
    setEditedStartDate (state, value) { state.adItem.edited.startDate = value },
    setEditedEndDate (state, value) { state.adItem.edited.endDate = value },
    setEditedType (state, value) { state.adItem.edited.type = value }
  }
}


// WEBPACK FOOTER //
// ./src/store/ads/ad-details.js